module.exports = __webpack_public_path__ + "static/media/Control_3_Thermocycler.e21903f2.svg";